var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgView(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "view",
    transform: "translate(-2.251 -11.25)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_36",
    "data-name": "Group 36",
    transform: "translate(2.251 11.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M30.2,20.941A15.557,15.557,0,0,0,16.251,11.25,15.557,15.557,0,0,0,2.307,20.941a.887.887,0,0,0,0,.618A15.557,15.557,0,0,0,16.251,31.25,15.557,15.557,0,0,0,30.2,21.559.887.887,0,0,0,30.2,20.941ZM16.251,29.432A13.856,13.856,0,0,1,4.183,21.25a13.856,13.856,0,0,1,12.068-8.182A13.856,13.856,0,0,1,28.319,21.25,13.856,13.856,0,0,1,16.251,29.432Z",
    transform: "translate(-2.251 -11.25)",
    fill: "#00c8ad"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M28.1,22.5a5.456,5.456,0,1,0,5.6,5.455A5.529,5.529,0,0,0,28.1,22.5Zm0,9.091a3.638,3.638,0,1,1,3.733-3.636A3.686,3.686,0,0,1,28.1,31.591Z",
    transform: "translate(-14.1 -17.955)",
    fill: "#00c8ad"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.4b1ee6c849b8d1988900d364d9f62419.svg";
export { ForwardRef as ReactComponent };